import ApiClient from './ApiClient';
import OnPremPORequestObject from '../models/entities/OnPremPORequestObject';
import SubmitPORequestObjectOnPrem from '../models/viewModels/OnPremPORequestObjects/SubmitPORequestObjectOnPrem';
import EscalateType from '../models/interfaces/EscalateType';
import RejectionModel from '../models/interfaces/RejectionModel';
import ChangeStatusObjectRequestOnPrem from '../models/viewModels/OnPremPORequestObjects/ChangeStatusObjectRequestOnPrem';
import UpdateOnPremObjectRequest from '../models/viewModels/OnPremPORequestObjects/UpdateOnPremObjectRequest';
import PortOpeningRequestApproverVerification from '../models/viewModels/PortOpeningRequests/PortOpeningRequestApproverVerification';
import NetworkConnection from '../models/entities/NetworkConnection';
import OnPremPortOpeningObject from '../models/entities/OnPremPortOpeningObject';
import OnPremPORequestObjectOptimized from '../models/entities/OnPremPORequestObjectOptimized';
import PageResult from '../models/entities/PageResult';

export default class OnPremPORequestObjectService extends ApiClient {
	
	async getById(id: number) : Promise<OnPremPORequestObject> {
		return this.get<OnPremPORequestObject>(`OnPremObjectRequests/${id}`);
	}

	async getNCDBbyTrackerId(trackerId: number) {
		return this.get<NetworkConnection>(`OnPremObjectRequests/ncdb/${trackerId}`);
	}
	
	async create(por: SubmitPORequestObjectOnPrem) : Promise<OnPremPORequestObject> {
		return this.post<OnPremPORequestObject>('OnPremObjectRequests', por);
	}
	
	async getAll(page: string) {
		return this.get<PageResult>(`OnPremObjectRequests?Page=${page}&PageSize=100`);
	}

	async getAllOptimized() {
    	return this.get<OnPremPORequestObjectOptimized[]>('OnPremObjectRequests/optimized');
    }

	async verifyApproverLevel(email: string, isEmergency: boolean) {
		return this.get<PortOpeningRequestApproverVerification>(`PortOpeningRequests/verifyApproverLevel?email=${email}&emergency=${isEmergency}`);
	}

	getCompletedOrPendingObjects = async () =>
		this.get<OnPremPORequestObject[]>('OnPremObjectRequests/CompleteAndPending').then((data) =>
			data.map((item) => new OnPremPORequestObject(item))
		);
	
	getImplementedObjects = async () =>
		this.get<OnPremPortOpeningObject[]>('OnPremObjectRequests/implementedObjects').then((data) =>
			data.map((item) => new OnPremPortOpeningObject(item)))
	
	async parse(file: File) {
		const formData = new FormData();
		formData.append(file.name, file);
		return this.postFormData('parse/onPremObjects', formData);
	}
	
	async approve(model: ChangeStatusObjectRequestOnPrem, id: number) {
		return this.patch<OnPremPORequestObject>(`OnPremObjectRequests/${id}/approval`, model);
	}
	
	async doEscalation( escalate: EscalateType, id: number) {
		if (escalate.OTCRMApproval) {
			return this.patch<OnPremPORequestObject>(`OnPremObjectRequests/${id}/escalateotcrm`, escalate);
		} else {
			return this.patch<OnPremPORequestObject>(`OnPremObjectRequests/${id}/escalate`, escalate);
		}
	}
	
	async doComplete(complete: ChangeStatusObjectRequestOnPrem, id: number) {
		return this.patch<OnPremPORequestObject>(`OnPremObjectRequests/${id}/completion`, complete);
	} 
	
	async reject(id: number, rejectionModel: RejectionModel) {
		return this.patch<null>(`OnPremObjectRequests/${id}/rejection`, rejectionModel);
	}
	
	async cancel(id: number, cancellationModel: ChangeStatusObjectRequestOnPrem) {
		return this.patch<OnPremPORequestObject>(
			`OnPremObjectRequests/${id}/cancellation`,
			cancellationModel
		);
	}

	async sendToReview(id: number, review: ChangeStatusObjectRequestOnPrem) {
		return this.patch<null>(`OnPremObjectRequests/${id}/review`, review);
	}

	async update(id: number, por: UpdateOnPremObjectRequest) {
		return this.patch<OnPremPORequestObject>(`OnPremObjectRequests/${id}`, por);
	}
}